import type { IconSvgObject } from './types';

const RegexIcon: IconSvgObject = [
  ["path", { d: "M16.6626 3V13M20.9952 5.49567L12.335 10.4957M21.0002 10.4961L12.34 5.49609", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 19.5V15.5C3 14.6716 3.67157 14 4.5 14H8.5C9.32843 14 10 14.6716 10 15.5V19.5C10 20.3284 9.32843 21 8.5 21H4.5C3.67157 21 3 20.3284 3 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RegexIcon;
